import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getStatus } from '@redux/modules/impersonation';
import {
  selectIsImpersonating,
  getImpersonationStateChange,
} from '@redux/selectors/ImpersonationSelector';

import {
  selectCanImpersonate,
  selectCanBeImpersonatedBy,
} from '@redux/selectors/TeamsManagementSelector';
import { getUser } from '@redux/selectors/UserSelector';
import { searchTeamMember } from '@redux/modules/teamsManagement';

import TeamLeadersTable from '@components/table/TeamLeadersTable';
import Card from '@components/smartAdminUI/Card';
import TeamMembersTable from '../../table/TeamMembersTable';

const ListingImpersonation = () => {
  const isImpersonationStateChange = useSelector(getImpersonationStateChange);
  const isImpersonating = useSelector(selectIsImpersonating);
  const canImpersonateData = useSelector(selectCanImpersonate);
  const canBeImpersonatedByData = useSelector(selectCanBeImpersonatedBy);
  const user = useSelector(getUser);

  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.UniqueID) {
      // Retrieve the teams details for current agent.
      dispatch(searchTeamMember({ targetMemberkey: user.UniqueID }));
    }
  }, [user]);

  useEffect(() => {
    dispatch(getStatus());
  }, [isImpersonating]);

  useEffect(() => {
    if (isImpersonationStateChange) window.location.href = '/';
  }, [isImpersonationStateChange]);

  return (
    <div>
      <Card title="Who can impersonate me:">
        <TeamMembersTable
          displayData={canBeImpersonatedByData}
          showDeleteButton={false}
        />
      </Card>
      <div style={{ margin: '1em 0' }} />
      <Card title="Who I can impersonate:">
        <TeamLeadersTable
          displayData={canImpersonateData}
          showDeleteButton={false}
          showStartImpersonationButton
        />
      </Card>
    </div>
  );
};

ListingImpersonation.propTypes = {
};

export default ListingImpersonation;
